import * as yup from "yup";

export const addParentOrganisationSchema = yup.object().shape({
    parentOrganization: yup.string()
}).required();